// test1096
(1096 && 0);
